// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as $$String from "../../../../../../../node_modules/rescript/lib/es6/string.js";
import * as Pervasives from "../../../../../../../node_modules/rescript/lib/es6/pervasives.js";
import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as GeoCodingApi from "../../../../../../library/components/generic-components/components/GeoCodingApi.bs.js";
import * as Row$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as Icon$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/icons/Icon.bs.js";
import * as CountryContext from "../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as Column$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Column.bs.js";
import * as PlaceOrderContext from "../../context/PlaceOrderContext.bs.js";
import * as FormInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInput.bs.js";
import * as PlaceOrderGaConfig from "../../../app/helper/PlaceOrderGaConfig.bs.js";
import * as FormHelper$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormHelper.bs.js";
import * as Api from "@react-google-maps/api";
import * as FormTextInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormTextInput.bs.js";
import * as FormSingleCheckBoxInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormSingleCheckBoxInput.bs.js";

function PickupDropFormCmp(Props) {
  var getSubmitDetails = Props.getSubmitDetails;
  var form = Props.form;
  var address_type = Props.address_type;
  var closeForm = Props.closeForm;
  var showCloseOpt = Props.showClose;
  var showClose = showCloseOpt !== undefined ? showCloseOpt : false;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var match$1 = PlaceOrderContext.useContext(undefined);
  var customerInfo = match$1.state.customerInfo;
  var countryRestriction;
  switch (country.TAG | 0) {
    case /* UAE */0 :
        countryRestriction = ["ae"];
        break;
    case /* India */1 :
        countryRestriction = ["in"];
        break;
    case /* BD */2 :
        countryRestriction = ["bd"];
        break;
    case /* TR */3 :
        countryRestriction = ["tr"];
        break;
    case /* MY */4 :
        countryRestriction = ["my"];
        break;
    
  }
  var match$2 = React.useState(function () {
        
      });
  var setAutoComplete = match$2[1];
  var autocomplete = match$2[0];
  var match$3 = React.useState(function () {
        return form.input.senderPhone === customerInfo.mobile;
      });
  var setNumberChecked = match$3[1];
  var numberChecked = match$3[0];
  var isPickupAddress = function (param) {
    if (address_type === "pickup") {
      return true;
    } else {
      return false;
    }
  };
  var getLabel = function (param) {
    switch (address_type) {
      case "drop" :
          return "To";
      case "pickup" :
          return "FROM";
      case "waypoint_1" :
          return "POINT 1";
      case "waypoint_2" :
          return "POINT 2";
      case "waypoint_3" :
          return "POINT 3";
      case "waypoint_4" :
          return "POINT 4";
      default:
        return "FROM";
    }
  };
  var getPinClass = function (param) {
    switch (address_type) {
      case "drop" :
          return "red";
      case "pickup" :
          return "green";
      case "waypoint_1" :
      case "waypoint_2" :
      case "waypoint_3" :
      case "waypoint_4" :
          return "blue";
      default:
        return "green";
    }
  };
  return React.createElement("div", {
              className: "address-container"
            }, React.createElement("div", {
                  className: "c-place-order_address"
                }, React.createElement("div", {
                      className: "progress-container"
                    }, React.createElement("div", {
                          className: "pin pin__" + getPinClass(undefined)
                        }), React.createElement("div", {
                          className: "track_line"
                        })), React.createElement("div", {
                      className: "c-place-order_address_container"
                    }, React.createElement("div", {
                          className: "label-container"
                        }, React.createElement("p", {
                              className: "label"
                            }, getLabel(undefined)), showClose ? React.createElement("p", {
                                onClick: (function (param) {
                                    return Curry._1(closeForm, undefined);
                                  })
                              }, React.createElement(Icon$Catalyst.CloseIcon.make, {
                                    fontSize: "Large"
                                  })) : null), React.createElement("div", {
                          className: "c-place-order_form"
                        }, React.createElement(Row$Catalyst.make, {
                              children: React.createElement(Column$Catalyst.make, {
                                    children: React.createElement(Api.Autocomplete, {
                                          onLoad: (function (value) {
                                              return Curry._1(setAutoComplete, (function (param) {
                                                            return value;
                                                          }));
                                            }),
                                          onPlaceChanged: (function (param) {
                                              if (autocomplete === undefined) {
                                                return ;
                                              }
                                              var place = Caml_option.valFromOption(autocomplete).getPlace();
                                              return GeoCodingApi.getGeocodeFromPlaceId(place.place_id, (function (place_) {
                                                            var lat = place_.geometry.location.lat;
                                                            var lng = place_.geometry.location.lng;
                                                            Curry._2(getSubmitDetails, {
                                                                  lat: lat,
                                                                  lng: lng
                                                                }, form.input.addressLineOne);
                                                            return Curry._2(form.updateAddressLineOne, (function (input, value) {
                                                                          return {
                                                                                  addressLineOne: value,
                                                                                  addressLineTwo: input.addressLineTwo,
                                                                                  senderName: input.senderName,
                                                                                  senderPhone: input.senderPhone
                                                                                };
                                                                        }), place.name + " , " + place.formatted_address);
                                                          }), (function (param) {
                                                            
                                                          }));
                                            }),
                                          children: React.createElement(React.Fragment, undefined, React.createElement(FormTextInput$Catalyst.make, {
                                                    input_props: FormInput$Catalyst.make_props("Enter Landmark", (function ($$event) {
                                                            return Curry._2(form.updateAddressLineOne, (function (input, value) {
                                                                          return {
                                                                                  addressLineOne: value,
                                                                                  addressLineTwo: input.addressLineTwo,
                                                                                  senderName: input.senderName,
                                                                                  senderPhone: input.senderPhone
                                                                                };
                                                                        }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                                                          }), undefined, undefined, undefined, undefined, undefined, undefined, form.addressLineOneResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                                    textinput_props: {
                                                      value: form.input.addressLineOne
                                                    }
                                                  })),
                                          restrictions: {
                                            country: countryRestriction
                                          }
                                        }),
                                    className: "c-place-order_form__column"
                                  }),
                              className: "c-place-order_form__row"
                            }), React.createElement(Row$Catalyst.make, {
                              children: React.createElement(Column$Catalyst.make, {
                                    children: null,
                                    className: "c-place-order_form__column"
                                  }, React.createElement("p", {
                                        className: "label"
                                      }, "House/Apartment"), React.createElement(FormTextInput$Catalyst.make, {
                                        input_props: FormInput$Catalyst.make_props("Enter The Address", (function ($$event) {
                                                return Curry._2(form.updateAddressLineTwo, (function (input, value) {
                                                              return {
                                                                      addressLineOne: input.addressLineOne,
                                                                      addressLineTwo: value,
                                                                      senderName: input.senderName,
                                                                      senderPhone: input.senderPhone
                                                                    };
                                                            }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                                              }), undefined, undefined, undefined, undefined, undefined, undefined, form.addressLineTwoResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                        textinput_props: {
                                          value: form.input.addressLineTwo
                                        }
                                      })),
                              className: "c-place-order_form__row"
                            }), React.createElement(Row$Catalyst.make, {
                              children: null,
                              className: "c-place-order_form__row"
                            }, React.createElement(Column$Catalyst.make, {
                                  children: null,
                                  className: "c-place-order_form__column"
                                }, React.createElement("p", {
                                      className: "label"
                                    }, (
                                      isPickupAddress(undefined) ? "Sender" : "Receiver"
                                    ) + " Name"), React.createElement(FormTextInput$Catalyst.make, {
                                      input_props: FormInput$Catalyst.make_props("Enter Name", (function ($$event) {
                                              return Curry._2(form.updateSenderName, (function (input, value) {
                                                            return {
                                                                    addressLineOne: input.addressLineOne,
                                                                    addressLineTwo: input.addressLineTwo,
                                                                    senderName: value,
                                                                    senderPhone: input.senderPhone
                                                                  };
                                                          }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                                            }), undefined, undefined, undefined, undefined, undefined, undefined, form.senderNameResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                      textinput_props: {
                                        value: form.input.senderName
                                      }
                                    })), React.createElement(Column$Catalyst.make, {
                                  children: null,
                                  className: "c-place-order_form__column"
                                }, React.createElement("p", {
                                      className: "label"
                                    }, (
                                      isPickupAddress(undefined) ? "Sender" : "Receiver"
                                    ) + " Phone Number"), React.createElement(FormTextInput$Catalyst.make, {
                                      input_props: FormInput$Catalyst.make_props("Enter Phone Number", (function ($$event) {
                                              return Curry._2(form.updateSenderPhone, (function (input, value) {
                                                            return {
                                                                    addressLineOne: input.addressLineOne,
                                                                    addressLineTwo: input.addressLineTwo,
                                                                    senderName: input.senderName,
                                                                    senderPhone: value
                                                                  };
                                                          }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                                            }), numberChecked, undefined, undefined, undefined, undefined, undefined, form.senderPhoneResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                      textinput_props: {
                                        value: form.input.senderPhone
                                      }
                                    }))), React.createElement(Row$Catalyst.make, {
                              children: React.createElement(Column$Catalyst.make, {
                                    children: React.createElement(FormSingleCheckBoxInput$Catalyst.make, {
                                          input_props: FormInput$Catalyst.make_props("", (function (param) {
                                                  Curry._2(form.updateSenderPhone, (function (input, value) {
                                                          return {
                                                                  addressLineOne: input.addressLineOne,
                                                                  addressLineTwo: input.addressLineTwo,
                                                                  senderName: input.senderName,
                                                                  senderPhone: value
                                                                };
                                                        }), numberChecked ? (Curry._2(form.updateSenderName, (function (input, value) {
                                                                  return {
                                                                          addressLineOne: input.addressLineOne,
                                                                          addressLineTwo: input.addressLineTwo,
                                                                          senderName: value,
                                                                          senderPhone: input.senderPhone
                                                                        };
                                                                }), ""), "") : customerInfo.mobile);
                                                  PlaceOrderGaConfig.publishEvent({
                                                        category: /* PickUpDrop */1,
                                                        action: $$String.capitalize_ascii(address_type) + " Checkbox",
                                                        label: "1_previous-" + Pervasives.string_of_bool(numberChecked) + "#2_updated-" + Pervasives.string_of_bool(!numberChecked) + "#3_" + customerInfo.mobile,
                                                        value: undefined,
                                                        nonInteraction: undefined
                                                      }, country);
                                                  return Curry._1(setNumberChecked, (function (param) {
                                                                return !numberChecked;
                                                              }));
                                                }), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                          checked: numberChecked,
                                          label: "Use Customer Number " + customerInfo.mobile
                                        }),
                                    className: "c-place-order_form__column"
                                  })
                            })))));
}

var make = PickupDropFormCmp;

export {
  make ,
  
}
/* react Not a pure module */
